import controller from './lead-time.controller';
import template from './lead-time.html';

export default { controller, template };



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/lead-time/lead-time.component.js